<template>
  <DataTable
    :value="items"
    :loading="isLoading"
    :resizableColumns="false"
    :paginator="false"
    class="center-screen mt-5 shadow-2"
    style="border-radius: 6px; min-height: 400px"
  >
    <template #empty> Aún no hay formularios SIFCOP para los filtros seleccionados. </template>

    <Column field="fecha">
      <template #header>
        <div class="headerContent">Fecha</div>
      </template>
      <template #body="{ data }">
        <div class="cellContent">{{ formatDate(data.fecha) }}</div>
      </template>
    </Column>
    <Column field="identificacion">
      <template #header>
        <div class="headerContent">Identificación</div>
      </template>
      <template #body="{ data }">
        <div class="cellContent">{{ data.identificacion }}</div>
      </template>
    </Column>
    <Column field="dependencia">
      <template #header>
        <div class="headerContent">Dependencia</div>
      </template>
      <template #body="{ data }">
        <div class="cellContent">{{ data.dependencia }}</div>
      </template>
    </Column>
    <Column>
      <template #header>
        <div class="headerContent">Acciones</div>
      </template>
      <template #body="{ data }">
        <div class="w-full flex justify-content-center gap-2 flex-wrap">
          <Button class="seeButton" @click="emit('view', data)">
            <div class="mt-1">
              <Eye color="white" :size="20" />
            </div>
            Ver
          </Button>
          <Button
            class="pdfButton"
            :disabled="Boolean(generatingPdfId)"
            @click="emit('generate-pdf', data)"
          >
            {{
              generatingPdfId !== null && `${generatingPdfId}` === `${data.id}`
                ? "Generando PDF..."
                : "Generar PDF"
            }}
          </Button>
        </div>
      </template>
    </Column>
  </DataTable>
</template>

<script setup>
import { Eye } from "lucide-vue";

defineProps({
  items: {
    type: Array,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  generatingPdfId: {
    type: [Number, String],
    default: null,
  },
});

const emit = defineEmits(["view", "generate-pdf"]);

const formatDate = (value) => {
  if (!value) return "-";

  const [year, month, day] = value.split("-");
  return `${day}/${month}/${year}`;
};
</script>

<style scoped>
.seeButton,
.pdfButton {
  display: flex;
  width: 124px;
  height: 36px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 6px;
  box-shadow: 0px 1px 3px 0px rgba(166, 175, 195, 0.4);
  white-space: nowrap;
}

.seeButton:hover,
.pdfButton:hover {
  opacity: 0.9;
  cursor: pointer;
}

.seeButton {
  background-color: var(--Primary, #0b5195);
  color: white;
  border: none;
}

.seeButton:hover {
  background-color: var(--Primary, #0b5095c5) !important;
}

.pdfButton {
  width: 148px;
  background: #fff;
  border: 1px solid #0b5195;
  color: #0b5195;
}

.pdfButton:hover {
  background: #f4f4f4 !important;
  color: #0b5195 !important;
}

.center-screen {
  margin: 0 auto 1rem auto;
}

.headerContent {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: bold;
}

.cellContent {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

>>> .p-datatable .p-column-header-content {
  justify-content: center;
  font-weight: bold;
}

>>> .p-datatable .p-datatable-tbody > tr > td {
  text-align: center;
}

>>> .p-datatable-table {
  table-layout: fixed;
}

>>> .p-datatable-wrapper .p-datatable-table {
  min-height: 100%;
}
</style>
